import React from 'react'
import { MAX_FILE_SIZE_BYTES } from 'src/app/BulkInvite/bulkInvite.constants'
import ErrorState from 'src/app/BulkInvite/components/ErrorState'
import LoadingState from 'src/app/BulkInvite/components/LoadingState'
import PrepareCsvCard from 'src/app/BulkInvite/components/PrepareCsvCard'
import { useBulkInvite } from 'src/app/BulkInvite/context/BulkInviteContext'
import * as style from 'src/app/BulkInvite/steps/UploadStep.style'
import { useBulkInviteStrings } from 'src/app/BulkInvite/useBulkInviteStrings'
import CsvDropzone from 'src/components/CsvDropzone/CsvDropzone'

const UploadStep: React.FC = () => {
  const { uploading, uploadError, uploadErrorDetail, acceptFile, resetUpload } =
    useBulkInvite()
  const strings = useBulkInviteStrings()

  if (uploading) {
    return (
      <LoadingState
        title={strings.uploadParsing}
        detail={strings.uploadParsingDetail}
      />
    )
  }

  if (uploadError) {
    return (
      <ErrorState
        title={strings.uploadError}
        // Prefer the backend's actionable message; fall back to generic copy so
        // the inline backend error surfacing is preserved.
        detail={uploadErrorDetail ?? strings.uploadErrorDetail}
        onRetry={resetUpload}
        retryLabel={strings.uploadRetry}
      />
    )
  }

  return (
    <div css={style.root}>
      <div css={style.columns}>
        {/* LEFT: receipt-capture-style CSV dropzone, wired to the same context
            upload path the step has always used (acceptFile). */}
        <div css={style.mainColumn}>
          <CsvDropzone
            onFile={acceptFile}
            inputAriaLabel={strings.uploadInputAriaLabel}
            promptText={strings.uploadDropPrompt}
            promptLinkText={strings.uploadBrowseLink}
            hint={strings.uploadDropzoneHint}
            maxSize={MAX_FILE_SIZE_BYTES}
          />
        </div>

        {/* RIGHT: "Preparing your CSV" info card (replaces the HRIS accordion). */}
        <aside css={style.aside}>
          <PrepareCsvCard />
        </aside>
      </div>
    </div>
  )
}

export default UploadStep
